import { Component, OnInit } from '@angular/core';
import { PromemoriaService } from 'src/app/core/promemoria.service';
import { Promemoria } from 'src/app/shared/models/promemoria.model';
import { PaginatorState } from 'primeng/paginator';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-promemoria',
  templateUrl: './promemoria.component.html',
  styleUrls: ['./promemoria.component.scss']
})
export class PromemoriaComponent implements OnInit {

  listaPromemorie: Promemoria[] = [];
  listaFiltrata: Promemoria[] = [];
  pagedPromemorie: Promemoria[] = [];
  selectedPromemoria: Promemoria | null = null;
  first: number = 0;
  rows: number = 7;
  testoRicerca: string = '';
  formDettaglio!: FormGroup;
  modaleVisibile: boolean = false;

  private readonly ricercaSubject = new Subject<string>();

  constructor(
    private readonly promemoriaService: PromemoriaService,
    private readonly fb: FormBuilder
  ) {
    this.formDettaglio = this.fb.group({
      creatoDa: [{ value: '', disabled: true }],
      dataCreazione: [{ value: '', disabled: true }],
      modificatoDa: [{ value: '', disabled: true }],
      dataModifica: [{ value: '', disabled: true }],
      testo: [{ value: '', disabled: true }]
    });
  }

  ngOnInit(): void {
    this.fetchPromemorie();

    this.ricercaSubject.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(testo => {
      this.applicaFiltro(testo);
    });
  }

  onRicercaChange(testo: string): void {
    this.ricercaSubject.next(testo);
  }

  clearRicerca(): void {
    this.testoRicerca = '';
    this.ricercaSubject.next('');
  }

  openCreateModal(): void {
    this.modaleVisibile = true;
  }

  onPromemoriaCreato(): void {
    this.modaleVisibile = false;
    this.first = 0;
    this.fetchPromemorie();
  }

  onPromemoriaAggiornato(): void {
    this.selectedPromemoria = null;
    this.fetchPromemorie();
  }

  onPageChange(event: PaginatorState): void {
    this.first = event.first ?? 0;
    this.rows = event.rows ?? 7;
    this.updatePagedPromemorie();
  }

  onSelectPromemoria(promemoria: Promemoria): void {
    this.selectedPromemoria = promemoria;
  }

  private fetchPromemorie(): void {
    this.promemoriaService.loadPromemorie().subscribe(lista => {
      this.listaPromemorie = lista;
      this.applicaFiltro(this.testoRicerca);
    });
  }

  private applicaFiltro(testo: string): void {
    this.first = 0;
    const termine = testo.trim().toLowerCase();

    this.listaFiltrata = termine
      ? this.listaPromemorie.filter(p =>
          p.testo.toLowerCase().includes(termine) ||
          p.creatoDa.toLowerCase().includes(termine) ||
          (p.modificatoDa ?? '').toLowerCase().includes(termine)
        )
      : [...this.listaPromemorie];

    this.updatePagedPromemorie();
  }

  private updatePagedPromemorie(): void {
    this.pagedPromemorie = this.listaFiltrata.slice(this.first, this.first + this.rows);
  }
}